export enum BOPO_TYPES {
	bopo = 'bopo',
	noBopo = 'noBopo',
}
